<template>
  <div class="home">
    <div class="widget">
      <div class="bubble-chat" :class="isToggle ? 'expanded' : 'collapsed'">
        <chat v-if="isToggle" @endSession="endSession" />
      </div>

      <div
        class="invite-message"
        :class="isInviteShow && inviteMessage ? 'invite-show' : 'invite-hide'"
      >
        {{ inviteMessage }}
      </div>
      <div class="open-chat">
        <img
          ref="widget"
          :src="isToggle ? iconDown : '/images/logo.png'"
          alt="icon"
          @click="isRotate = true"
          :class="isRotate ? 'rotate' : ''"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Chat from '../widget/chat/index'

export default {
  name: 'Widget',
  components: {
    Chat
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      isRotate: false,
      isToggle: false,
      isInviteShow: false,
      inviteMessage: 'คุยกันแอดมิน',
      iconDown: require('@/assets/icon/icon-down.png')
    }
  },
  created() {},
  async mounted() {
    try {
      this.$refs.widget.addEventListener('animationend', () => {
        this.isInviteShow = !this.isInviteShow
        this.isToggle = !this.isToggle
        this.isRotate = false
      })
      setTimeout(() => {
        this.isInviteShow = true
      }, 100)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    endSession() {
      if (this.isToggle) this.isRotate = true
    }
  }
}
</script>

<style scoped lang="scss">
$chat-width: calc(100% - 18px);
$chat-width-max: 350px;
$chat-height: 430px;
$dark-primary: $primary;

.widget {
  position: fixed;
  bottom: 25px;
  width: 100%;
  max-width: 720px;
  z-index: 1000;

  .invite-message {
    font-size: 18px;
    color: black;
    position: absolute;
    right: 25px;
    bottom: 90px;
    background: white;
    padding: 8px 10px;
    border-radius: 10px;
    box-shadow: 1px 1px 3px 3px rgba(0, 0, 0, 0.2);
    max-width: 290px;
    width: calc(100% - 100px);

    &.invite-hide {
      opacity: 0;
      transform: translate(130%, 0);
      transition: 0.3s;
    }

    &.invite-show {
      opacity: 1;
      transition: 0.3s;
    }
  }

  .bubble-chat {
    display: inline-block;
    border-radius: 10px;
    width: $chat-width;
    max-width: $chat-width-max;
    max-height: $chat-height;
    height: calc(100vh - 120px);
    margin-bottom: 5px;
    position: absolute;
    right: 20px;
    bottom: 145px;
    overflow: hidden;

    &.expanded {
      opacity: 1;
      visibility: visible;
      animation: fadeIn 0.7s;
      box-shadow: 1px 1px 3px 3px rgba(0, 0, 0, 0.2);
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
        // from {
        //   width: 0px;
        //   height: 0px;
        // }
        // to {
        //   width: $chat-width;
        //   height: auto;
        // }
      }
    }

    &.collapsed {
      opacity: 0;
      display: none;
      transition: opacity 0.5s linear;
    }
  }

  .open-chat {
    background-color: $dark-primary;
    cursor: pointer;
    width: 60px;
    height: 60px;
    border: 2px solid white;
    border-radius: 50%;
    box-shadow: 1px 1px 3px 3px rgba(0, 0, 0, 0.2);
    position: absolute;
    right: 20px;
    bottom: 80px;

    img {
      max-height: 100%;
      max-width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 50%;
      transition: all 0.8s ease-in-out;
    }
  }

  .rotate {
    animation: rotate-keyframes 0.7s;
    @keyframes rotate-keyframes {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
